var _a, _b, _c, _d;
import { LANGUAGE } from '../constants';
import { COUNTRY_CODE } from '../constants';
var DEFAULT_NOTCH_BASE = 1000;
var DEFAULT_NOTCH_M = 1000000;
var DEFAULT_NOTCH_B = 1000000000;
var DEFAULT_NOTCH_TEN_THOUSAND = 10000;
var DEFAULT_NOTCH_HUNDRED_THOUSAND = 100000;
var DEFAULT_NOTCH_TEN_MILLION = 10000000;
var DEFAULT_NOTCH_HUNDRED_MILLION = 100000000;
var DEFAULT_NOTCH_TRILLION = 1000000000000;
export var DEFAULT_NOTCHES = [
    { notch: DEFAULT_NOTCH_B, unit: 'b' },
    { notch: DEFAULT_NOTCH_M, unit: 'm' },
    { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
];
var COUNTRY_AND_LANGUAGE_NOTCH_CONF = (_a = {},
    _a[COUNTRY_CODE.SG] = {
        default: DEFAULT_NOTCHES,
    },
    _a[COUNTRY_CODE.ID] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'M' },
            { notch: DEFAULT_NOTCH_M, unit: 'JT' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'RB' },
        ],
    },
    _a[COUNTRY_CODE.MY] = (_b = {
            default: DEFAULT_NOTCHES
        },
        _b[LANGUAGE.ms] = DEFAULT_NOTCHES,
        _b[LANGUAGE['zh-Hans']] = [
            { notch: DEFAULT_NOTCH_HUNDRED_MILLION, unit: '亿' },
            { notch: DEFAULT_NOTCH_TEN_THOUSAND, unit: '万' },
            { notch: DEFAULT_NOTCH_BASE, unit: '千' },
        ],
        _b),
    _a[COUNTRY_CODE.PH] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'B' },
            { notch: DEFAULT_NOTCH_M, unit: 'M' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'K' },
        ],
    },
    _a[COUNTRY_CODE.TW] = {
        default: [
            { notch: DEFAULT_NOTCH_HUNDRED_MILLION, unit: '億' },
            { notch: DEFAULT_NOTCH_TEN_THOUSAND, unit: '萬' },
        ],
    },
    _a[COUNTRY_CODE.TH] = (_c = {
            default: [
                { notch: DEFAULT_NOTCH_M, unit: 'ล้าน' },
                { notch: DEFAULT_NOTCH_BASE, unit: 'พัน' },
            ]
        },
        _c[LANGUAGE.en] = DEFAULT_NOTCHES,
        _c),
    _a[COUNTRY_CODE.VN] = {
        default: [
            { notch: DEFAULT_NOTCH_M, unit: 'tr' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
        ],
    },
    _a[COUNTRY_CODE.IR] = {
        default: DEFAULT_NOTCHES,
    },
    _a[COUNTRY_CODE.MM] = {
        default: DEFAULT_NOTCHES,
    },
    _a[COUNTRY_CODE.HK] = {
        default: DEFAULT_NOTCHES,
    },
    _a[COUNTRY_CODE.CN] = {
        default: [{ notch: DEFAULT_NOTCH_TEN_THOUSAND, unit: '万' }],
    },
    _a[COUNTRY_CODE.BR] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'bi' },
            { notch: DEFAULT_NOTCH_M, unit: 'mi' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'mil' },
        ],
    },
    _a[COUNTRY_CODE.MX] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'mil millones' },
            { notch: DEFAULT_NOTCH_M, unit: 'millón' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'mil' },
        ],
    },
    _a[COUNTRY_CODE.CO] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'mil millones' },
            { notch: DEFAULT_NOTCH_M, unit: 'millón' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'mil' },
        ],
    },
    _a[COUNTRY_CODE.CL] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'mil millones' },
            { notch: DEFAULT_NOTCH_M, unit: 'millón' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'mil' },
        ],
    },
    _a[COUNTRY_CODE.AR] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'mm' },
            { notch: DEFAULT_NOTCH_M, unit: 'm' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
        ],
    },
    _a[COUNTRY_CODE.PL] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: ' mld' },
            { notch: DEFAULT_NOTCH_M, unit: ' mln' },
            { notch: DEFAULT_NOTCH_BASE, unit: ' tys.' },
        ],
    },
    _a[COUNTRY_CODE.ES] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'MM' },
            { notch: DEFAULT_NOTCH_M, unit: 'M' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
        ],
    },
    _a[COUNTRY_CODE.FR] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: ' Md' },
            { notch: DEFAULT_NOTCH_M, unit: ' M' },
            { notch: DEFAULT_NOTCH_BASE, unit: ' k' },
        ],
    },
    _a[COUNTRY_CODE.IN] = (_d = {
            default: [
                { notch: DEFAULT_NOTCH_TEN_MILLION, unit: ' करोड़' },
                { notch: DEFAULT_NOTCH_HUNDRED_THOUSAND, unit: ' लाख' },
                { notch: DEFAULT_NOTCH_BASE, unit: ' हजार' },
            ]
        },
        _d[LANGUAGE.en] = [
            { notch: DEFAULT_NOTCH_TEN_MILLION, unit: ' cr' },
            { notch: DEFAULT_NOTCH_HUNDRED_THOUSAND, unit: ' lakh' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
        ],
        _d),
    _a[COUNTRY_CODE.US] = {
        default: [
            { notch: DEFAULT_NOTCH_B, unit: 'B' },
            { notch: DEFAULT_NOTCH_M, unit: 'M' },
            { notch: DEFAULT_NOTCH_BASE, unit: 'k' },
        ],
    },
    _a[COUNTRY_CODE.KR] = {
        default: [
            { notch: DEFAULT_NOTCH_TEN_THOUSAND, unit: '만' },
            { notch: DEFAULT_NOTCH_HUNDRED_MILLION, unit: '억' },
            { notch: DEFAULT_NOTCH_TRILLION, unit: '조' },
        ],
    },
    _a);
export function getNotchesByCountryAndLanguage(country, language) {
    if (!country) {
        return DEFAULT_NOTCHES;
    }
    var countryConfig = COUNTRY_AND_LANGUAGE_NOTCH_CONF[country];
    var countryDefaultNotches = countryConfig.default;
    if (!language) {
        return countryDefaultNotches;
    }
    return countryConfig[language] || countryDefaultNotches;
}
